function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "svg-121053285-a",
  d: "M15.9 3.455a7.506 7.506 0 0 1 1.394 3.787h4.451a.98.98 0 0 1 .992.968v14.516c0 .89-1.127 1.308-1.732.643l-1.242-1.364-1.242 1.364a1.008 1.008 0 0 1-1.486-.004l-1.224-1.36-1.26 1.368a1.007 1.007 0 0 1-1.48-.007l-1.231-1.36-1.252 1.365c-.606.662-1.73.243-1.73-.645v-7.25c-2.252-.175-4.409-1.293-5.805-3.24a.954.954 0 0 1 .243-1.348 1.005 1.005 0 0 1 1.38.238 5.876 5.876 0 0 0 4.182 2.407V8.21a.98.98 0 0 1 .991-.968h5.454a5.604 5.604 0 0 0-1.028-2.677c-1.856-2.587-5.509-3.216-8.16-1.405-.408.28-.773.603-1.09.964l3.496 1.97-6.434 1.563L.255 1.435l3.031 1.708a7.76 7.76 0 0 1 1.692-1.568C8.526-.85 13.415-.008 15.9 3.455zm4.854 5.722h-9.913v11.015l.264-.289a1.007 1.007 0 0 1 1.482.005l1.234 1.363 1.262-1.37a1.008 1.008 0 0 1 1.482.009l1.22 1.354 1.237-1.359a1.008 1.008 0 0 1 1.482 0l.25.275V9.177zm-1.959 5.807a.968.968 0 1 1 0 1.935H12.8a.967.967 0 1 1 0-1.935h5.995zm0-3.871a.968.968 0 1 1 0 1.935H12.8a.967.967 0 1 1 0-1.935h5.995z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(3.94 3)"
}, React.createElement("mask", {
  id: "svg-121053285-b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#svg-121053285-a"
})), React.createElement("use", {
  fill: "#2E7C87",
  fillRule: "nonzero",
  xlinkHref: "#svg-121053285-a"
}), React.createElement("g", {
  fill: "#2E7C87",
  mask: "url(#svg-121053285-b)"
}, React.createElement("path", {
  d: "M-3-3h30.884v30H-3z"
})));

var SvgReorder = function SvgReorder(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 30
  }, props), React.createElement("title", null, title), _ref2, _ref3);
};

export default SvgReorder;